// import React from "react";

// const SkeletonBarChart = () => {
//   return (
//     <div className="bar-chart-container animate-pulse">
//       {/* Year Selector Skeleton */}
//       <div className="card-year-selector mb-5">
//         <div className="h-6 w-24 bg-gray-300 rounded mr-2 inline-block"></div>
//         <div className="h-10 w-32 bg-gray-300 rounded inline-block"></div>
//       </div>

//       {/* Data Type Selector Skeleton */}
//       <div className="data-type-selector mb-5">
//         <div className="h-6 w-24 bg-gray-300 rounded mr-2 inline-block"></div>
//         <div className="h-10 w-20 bg-gray-300 rounded mr-2 inline-block"></div>
//         <div className="h-10 w-20 bg-gray-300 rounded inline-block"></div>
//       </div>

//       {/* Total Sum/Count Skeleton */}
//       <div className="mb-5">
//         <div className="h-6 w-48 bg-gray-300 rounded"></div>
//       </div>

//       {/* Chart Skeleton */}
//       <div className="chart-container">
//         <div className="h-64 w-full bg-gray-300 rounded"></div>
//       </div>
//     </div>
//   );
// };

// const SkeletonLineChart = () => {
//   return (
//     <div className="line-chart-container animate-pulse">
//       {/* Year Selector Skeleton */}
//       <div className="card-year-selector mb-5">
//         <div className="h-6 w-24 bg-gray-300 rounded mr-2 inline-block"></div>
//         <div className="h-10 w-32 bg-gray-300 rounded inline-block"></div>
//       </div>

//       {/* Data Type Selector Skeleton */}
//       <div className="data-type-selector mb-5">
//         <div className="h-6 w-24 bg-gray-300 rounded mr-2 inline-block"></div>
//         <div className="h-10 w-20 bg-gray-300 rounded mr-2 inline-block"></div>
//         <div className="h-10 w-20 bg-gray-300 rounded inline-block"></div>
//       </div>

//       {/* Total Sum/Count Skeleton */}
//       <div className="mb-5">
//         <div className="h-6 w-48 bg-gray-300 rounded"></div>
//       </div>

//       {/* Chart Skeleton */}
//       <div className="chart-container">
//         <div className="h-64 w-full bg-gray-300 rounded"></div>
//       </div>
//     </div>
//   );
// };

// const SkeletonPieChart = () => {
//   return (
//     <div
//       className="animate-pulse"
//       style={{ width: "300px", height: "300px", margin: "auto" }}
//     >
//       <div className="h-full w-full bg-gray-300 rounded-full"></div>
//     </div>
//   );
// };

// const SkeletonDoughnutChart = () => {
//   return (
//     <div
//       className="animate-pulse"
//       style={{ width: "300px", height: "300px", margin: "auto" }}
//     >
//       <div className="h-full w-full bg-gray-300 rounded-full"></div>
//     </div>
//   );
// };

// export {
//   SkeletonBarChart,
//   SkeletonLineChart,
//   SkeletonPieChart,
//   SkeletonDoughnutChart,
// };



import React from "react";

const SkeletonBarChart = () => {
  return (
    <div className="bar-chart-container animate-pulse">
      {/* Year Selector Skeleton */}
      <div className="card-year-selector mb-5 flex items-center space-x-2">
        <div className="h-6 w-24 bg-gray-300 rounded"></div>
        <div className="h-10 w-32 bg-gray-300 rounded"></div>
      </div>

      {/* Data Type Selector Skeleton */}
      <div className="data-type-selector mb-5 flex items-center space-x-2">
        <div className="h-6 w-24 bg-gray-300 rounded"></div>
        <div className="h-10 w-20 bg-gray-300 rounded"></div>
        <div className="h-10 w-20 bg-gray-300 rounded"></div>
      </div>

      {/* Total Sum/Count Skeleton */}
      <div className="mb-5">
        <div className="h-6 w-48 bg-gray-300 rounded"></div>
      </div>

      {/* Chart Skeleton (bars) */}
      <div className="flex items-end justify-between h-64 w-full">
        <div className="w-6 bg-gray-300 rounded h-20"></div>
        <div className="w-6 bg-gray-300 rounded h-32"></div>
        <div className="w-6 bg-gray-300 rounded h-48"></div>
        <div className="w-6 bg-gray-300 rounded h-28"></div>
        <div className="w-6 bg-gray-300 rounded h-40"></div>
      </div>
    </div>
  );
};

const SkeletonLineChart = () => {
  return (
    <div className="line-chart-container animate-pulse">
      {/* Year Selector Skeleton */}
      <div className="card-year-selector mb-5 flex items-center space-x-2">
        <div className="h-6 w-24 bg-gray-300 rounded"></div>
        <div className="h-10 w-32 bg-gray-300 rounded"></div>
      </div>

      {/* Data Type Selector Skeleton */}
      <div className="data-type-selector mb-5 flex items-center space-x-2">
        <div className="h-6 w-24 bg-gray-300 rounded"></div>
        <div className="h-10 w-20 bg-gray-300 rounded"></div>
        <div className="h-10 w-20 bg-gray-300 rounded"></div>
      </div>

      {/* Total Sum/Count Skeleton */}
      <div className="mb-5">
        <div className="h-6 w-48 bg-gray-300 rounded"></div>
      </div>

      {/* Chart Skeleton (zigzag line) */}
      <svg viewBox="0 0 400 200" className="w-full h-64">
        <polyline
          points="0,150 80,100 160,130 240,70 320,110 400,50"
          className="stroke-gray-300 fill-none"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

const SkeletonPieChart = () => {
  return (
    <div
      className="animate-pulse flex items-center justify-center"
      style={{ width: "280px", height: "280px", margin: "auto" }}
    >
      <div className="h-full w-full bg-gray-300 rounded-full"></div>
    </div>
  );
};

const SkeletonDoughnutChart = () => {
  return (
    <div
      className="animate-pulse relative flex items-center justify-center"
      style={{ width: "280px", height: "280px", margin: "auto" }}
    >
      <div className="h-full w-full bg-gray-300 rounded-full"></div>
      <div className="absolute w-20 h-20 bg-white rounded-full"></div>
    </div>
  );
};

export {
  SkeletonBarChart,
  SkeletonLineChart,
  SkeletonPieChart,
  SkeletonDoughnutChart,
};
